export function getView(category_id, question_type, disabled) {
  return category_id !== 'habits' && question_type === 'boolean' && !disabled
}
